import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';


// Paste YOUR config here from Step 3!
const firebaseConfig = {
  apiKey: "AIzaSyBZ4LCDLnKfH0PXEyNUAt2q181YJQwPt0s",
  authDomain: "hollis-massage.firebaseapp.com",
  projectId: "hollis-massage",
  storageBucket: "hollis-massage.firebasestorage.app",
  messagingSenderId: "932444779421",
  appId: "1:932444779421:web:2b514010982af025ce3574"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

const auth = getAuth(app);
export { db, auth };

